<template>
  <div class="right-box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: { },
  data(){
    return{
       
    }
  },
methods:{

},
}
</script>
<style scoped lang="scss">
  .right-box{
    background: rgba($color: #fff, $alpha: 0.7);
    border-radius: 7rem;
    width: 52rem;
    padding: 6rem 3rem 0rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    margin-bottom: 9rem;
  }

</style>